// Обратный read-receipt: до какого ответа бизнеса посетитель ДОЧИТАЛ. Чистый
// модуль (DOM нет) — тестируется в изоляции (receipt.test.mjs), как blocks.ts.
//
// ЗАЧЕМ ГЕЙТ: поллинг ленты идёт и при свёрнутой панели, и на скрытой вкладке
// (бейдж/звук). Отметить «прочитано» по факту поллинга — соврать владельцу в
// кабинете. Честное «прочитано» = панель ОТКРЫТА, вкладка ВИДИМА и реплика
// реально отрисована в ленте (её id и приходит сюда как rendered).

/** Курсор отчёта о прочтении для очередного поллинга.
 *
 *  @param rendered id последней реплики бизнеса, ЛЕЖАЩЕЙ в ленте (0 — таких нет).
 *  @param reported курсор, уже принятый сервером (монотонность: назад не едем).
 *  @param opened панель чата раскрыта.
 *  @param visible вкладка перед глазами (document.visibilityState === 'visible').
 *  @return id для параметра seen_through; 0 — отмечать нечего, параметр не шлём
 *    (лишний UPDATE на каждый тик поллинга ни к чему). */
export function seenReportId(rendered: number, reported: number, opened: boolean, visible: boolean): number {
  if (!opened || !visible) return 0;
  return rendered > reported ? rendered : 0;
}
